import React, { ReactNode } from 'react';
import { SelectOption } from 'global';
import { Info } from '@mui/icons-material';
import { FieldValues } from 'react-hook-form/dist/types';
import { Stack, Tooltip, Typography } from '@mui/material';
import { Control } from 'react-hook-form/dist/types/form';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';

import { AutocompleteField } from '../form';

interface Props<FormValues extends FieldValues = FieldValues> {
  explanation?: ReactNode;
  mainRecipient: SelectOption;
  ccRecipients: Array<SelectOption>;
  formConnection: { name: UseControllerProps<FormValues>['name']; control: Control<FormValues> };
}

export const NotificationSection = <FormValues extends FieldValues = FieldValues>({
  formConnection,
  mainRecipient,
  explanation,
  ccRecipients,
}: Props<FormValues>) => {
  return (
    <Stack gap="0.5rem">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle2" component="span">
          Send Email To: {mainRecipient.label} - {mainRecipient.value}
        </Typography>

        {explanation && (
          <Tooltip placement="top" title={explanation}>
            <Info color="primary" fontSize="small" />
          </Tooltip>
        )}
      </Stack>

      <AutocompleteField
        multiple
        limitTags={3}
        disableCloseOnSelect
        options={ccRecipients}
        name={formConnection.name}
        control={formConnection.control}
        textFieldProps={{ label: 'CC Email to' }}
      />
    </Stack>
  );
};
